// extracted by mini-css-extract-plugin
var _1 = "eaQtL5jfU3";
var _2 = "wuvQDFWRqk";
var _3 = "JKFd2QtvkY";
var _4 = "e6VLBx3HZK";
var _5 = "be8ZGnYihn";
export { _1 as "gauge", _2 as "gaugeList", _3 as "name", _4 as "row", _5 as "value" }
